module.exports = __webpack_public_path__ + "img/img.977f6585.png";